import { defineStore } from "pinia";
const STATE_PATH = "/response-set";
export const useResponseSet = defineStore("response-set", {
    state: () => ({
        studyId: -1,
        responseDetailId: -1,
        userId: -1,
        activityId: -1,
        taskId: -1,
        entryIdx: -1,
        responseSet: {}
    }),
    actions: {
        onLoad(responseSet) {
            this.studyId = responseSet.studyId;
            this.responseDetailId = responseSet.responseDetailId;
            this.userId = responseSet.userId;
            this.activityId = responseSet.activityId;
            this.taskId = responseSet.taskId;
            this.entryIdx = responseSet.entryIdx;
            this.responseSet = responseSet.responseSet;
            return responseSet;
        },
        load() {
            //console.error("Context data could not be loaded from page.");
            return Promise.resolve({});
        }
    },
    loadable: {
        action: "load",
        autoload: true,
        reloadable: true,
        fromPage: {
            key: STATE_PATH,
            onLoad: "onLoad"
        }
    }
});
